module.exports = __webpack_public_path__ + "media/images/athletes/3472-7488a9dcb2696ef42e8ee14bed81a7b3.png";